import React from 'react';
import PropTypes from 'prop-types';
import { checkboxListValueType } from '../../types';
import { joinClassNames } from '../../utils';

CheckboxListValue.propTypes = {
    name: PropTypes.string.isRequired,
    value: checkboxListValueType.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

CheckboxListValue.defaultProps = {
    disabled: false,
};

function CheckboxListValue(props) {
    const {
        name,
        value,
        checked,
        onChange,
        disabled,
    } = props;
    const handleOnChange = (event) => onChange(event.target.checked);
    return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label className={joinClassNames('field--value', checked && 'checked', disabled && 'disabled')}>
            <input
                type="checkbox"
                name={name}
                checked={checked}
                disabled={disabled}
                onChange={handleOnChange}
            />
            {value.label}
        </label>
    );
}

export default CheckboxListValue;
